import { EditorialType, NodeTypeName, TitleTree, Node, AnnoNodeTypeName } from "../domain/domain"

export enum ComponentManagementActionType {
    TREE_ROOT_UPDATED = "TREE_ROOT_UPDATED",
    EDITOR_MODE_UPDATED = "EDITOR_MODE_UPDATED",
    EDITORIAL_CONTENT_MODE_CHANGED = "EDITORIAL_CONTENT_MODE_CHANGED",
    SELECTED_EDITORIAL_TYPE_CHANGED = "SELECTED_EDITORIAL_TYPE_CHANGED",
    SELECTED_ANNO_TYPE_CHANGED = "SELECTED_ANNO_TYPE_CHANGED",
    EDITORIAL_STATES_CHANGED = "EDITORIAL_STATES_CHANGED",
    EDITOR_NODE_UPDATED = "EDITOR_NODE_UPDATED",
    ADD_EDIT_NODE_DIALOG_OPEN = "ADD_EDIT_NODE_DIALOG_OPEN",
    APPROVE_EDITORIAL_CONTENT_DIALOG_OPEN = "APPROVE_EDITORIAL_CONTENT_DIALOG_OPEN",
    REJECT_EDITORIAL_CONTENT_DIALOG_OPEN = "REJECT_EDITORIAL_CONTENT_DIALOG_OPEN",
    EDITORIAL_CONTENT_HAS_CHANGES = "EDITORIAL_CONTENT_HAS_CHANGES",
    BILL_CONTENT_HAS_CHANGES = "BILL_CONTENT_HAS_CHANGES",
    APPROVE_COMPONENT_DIALOG_OPEN = "APPROVE_COMPONENT_DIALOG_OPEN",
    REJECT_COMPONENT_DIALOG_OPEN = "REJECT_COMPONENT_DIALOG_OPEN",
    OPEN_POPUP = "OPEN_POPUP",
    SUBTREE_CHANGED = "SUBTREE_CHANGED",
    SUBTREE_TITLE_CHANGED = "SUBTREE_TITLE_CHANGED",
    MARK_FOR_DELETION = "MARK_FOR_DELETION",
    STATUTE_MARK_FOR_DELETION = "STATUTE_MARK_FOR_DELETION",
    DIFF_HAS_CHANGES = "DIFF_HAS_CHANGES",
    ANNO_HAS_CHANGES = "ANNO_HAS_CHANGES",
    REMOVE_NODE_DIALOG_OPEN = "REMOVE_NODE_DIALOG_OPEN",
    REPEAL_NODE_DIALOG_OPEN = "REPEAL_NODE_DIALOG_OPEN",
    APPROVE_ALL_NODE_DIALOG_OPEN = "APPROVE_ALL_NODE_DIALOG_OPEN",
    REJECT_ALL_DIALOG_OPEN = "REJECT_ALL_DIALOG_OPEN",
    HEADING_CHANGED = "HEADING_CHANGED",
    STATUTORY_CONTENT_CHANGED = "STATUTORY_CONTENT_CHANGED",
    EDITORIAL_CONTENT_CHANGED = "EDITORIAL_CONTENT_CHANGED",
}

export interface EditorNodeUpdated {
    type: ComponentManagementActionType.EDITOR_NODE_UPDATED,
    editorNode: Node
}

export interface TreeRootUpdated {
    type: ComponentManagementActionType.TREE_ROOT_UPDATED,
    treeRoot: TitleTree | undefined
}

export interface EditorModeUpdated {
    type: ComponentManagementActionType.EDITOR_MODE_UPDATED,
    editorMode: "edit" | "view"
}

export interface EditorialContentModeChanged {
    type: ComponentManagementActionType.EDITORIAL_CONTENT_MODE_CHANGED,
    editorialContentMode: "edit" | "view"
}

export interface SelectedEditorialTypeChanged {
    type: ComponentManagementActionType.SELECTED_EDITORIAL_TYPE_CHANGED,
    selectedEditorialType: EditorialType
}

export interface SelectedAnnoTypeChanged {
    type: ComponentManagementActionType.SELECTED_ANNO_TYPE_CHANGED,
    selectedAnnoType: AnnoNodeTypeName
}


export interface EditorialStatesChanged {
    type: ComponentManagementActionType.EDITORIAL_STATES_CHANGED,
    editorialStates:  Map<EditorialType, string>
    currentEditorTextForAnnotation: string
}

export interface ApproveEdiorialContentDialogOpen {
    type: ComponentManagementActionType.APPROVE_EDITORIAL_CONTENT_DIALOG_OPEN,
    open: boolean
}

export interface RejectEdiorialContentDialogOpen {
    type: ComponentManagementActionType.REJECT_EDITORIAL_CONTENT_DIALOG_OPEN,
    open: boolean
}

export interface ApproveComponentDialogOpen {
    type: ComponentManagementActionType.APPROVE_COMPONENT_DIALOG_OPEN,
    open: boolean
}

export interface RejectComponentDialogOpen {
    type: ComponentManagementActionType.REJECT_COMPONENT_DIALOG_OPEN,
    open: boolean
}

export interface EditorialContentHasChanges {
    type: ComponentManagementActionType.EDITORIAL_CONTENT_HAS_CHANGES,
    hasChanges: boolean
}

export interface BillContentHasChanges {
    type: ComponentManagementActionType.BILL_CONTENT_HAS_CHANGES,
    billHasChanges: boolean
}

export interface MarkForDeletion{
    type: ComponentManagementActionType.MARK_FOR_DELETION,
    mark: boolean
}

export interface StatuteMarkForDeletion{
    type: ComponentManagementActionType.STATUTE_MARK_FOR_DELETION,
    mark: boolean
}

export interface DiffHasChanges{
    type: ComponentManagementActionType.DIFF_HAS_CHANGES,
    diffChanges: true;
}

export interface AnnoHasChanges{
    type: ComponentManagementActionType.ANNO_HAS_CHANGES,
    annoChanges: true;
}

export interface SubtreeChanged {
    type: ComponentManagementActionType.SUBTREE_CHANGED,
    nodeId: number,
    hasChanges: boolean,
    changesInNode: boolean
}

export interface SubtreeTitleChanged {
    type: ComponentManagementActionType.SUBTREE_TITLE_CHANGED,
    newHeading: string,
    newCitation: string,
    newCitationPart: string,
    newWorkingCopyHeading: string | undefined,
    newWorkingCopyCitation: string | undefined,
    nodeId: number,
    repealed: boolean,
}

export interface AddEditNodeDialogOpen {
    type: ComponentManagementActionType.ADD_EDIT_NODE_DIALOG_OPEN,
    open: boolean,
    mode: "add" | "edit",
    subTree: TitleTree | undefined,
    nodeType: NodeTypeName | undefined,
    ordinal: number | undefined,
    direction: String | undefined,
    grandParentNode: TitleTree | undefined,
}

export interface RemoveNodeDialogOpen {
    type: ComponentManagementActionType.REMOVE_NODE_DIALOG_OPEN,
    open: boolean,
    subTree: TitleTree | undefined
}

export interface RepealNodeDialogOpen{
    type: ComponentManagementActionType.REPEAL_NODE_DIALOG_OPEN,
    open: boolean,
    subTree: TitleTree | undefined
}

export interface ApproveAllNodeDialogOpen{
    type: ComponentManagementActionType.APPROVE_ALL_NODE_DIALOG_OPEN,
    open: boolean
}

export interface RejectAllDialogOpen{
    type: ComponentManagementActionType.REJECT_ALL_DIALOG_OPEN,
    open: boolean,
    subTree: TitleTree | undefined
}

export interface HeadingChanged {
    type: ComponentManagementActionType.HEADING_CHANGED,
    nodeId: number,
    headingHasChanges: boolean
}

export interface StatutoryContentChanged {
    type: ComponentManagementActionType.STATUTORY_CONTENT_CHANGED,
    nodeId: number,
    statutoryContentHasChanges: boolean
}

export interface EditorialContentChanged {
    type: ComponentManagementActionType.EDITORIAL_CONTENT_CHANGED,
    nodeId: number,
    editorialContentHasChanges: boolean
}

export type ComponentManagementActions =
            ApproveComponentDialogOpen |
            RejectComponentDialogOpen |
            ApproveEdiorialContentDialogOpen |
            RejectEdiorialContentDialogOpen |
            EditorialContentHasChanges |
            AddEditNodeDialogOpen |
            EditorNodeUpdated |
            EditorialStatesChanged |
            SelectedEditorialTypeChanged |
            SelectedAnnoTypeChanged |
            TreeRootUpdated |
            EditorModeUpdated |
            EditorialContentModeChanged |
            BillContentHasChanges |
            SubtreeChanged |
            SubtreeTitleChanged |
            MarkForDeletion |
            StatuteMarkForDeletion |
            DiffHasChanges |
            AnnoHasChanges |
            RemoveNodeDialogOpen |
            RepealNodeDialogOpen |
            ApproveAllNodeDialogOpen |
            RejectAllDialogOpen |
            HeadingChanged |
            StatutoryContentChanged |
            EditorialContentChanged;
